<template>
<div id="container">
  <div class="product-status">
    <div class="bold"></div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="item.title" :name="item.name"  v-for="item in managementSetList" :key="item.name">
        <!-------------- 基础资料配置 -------------->
        <div class="customer-config">
          <div class="config-instruction">
            <i class="el-icon-warning-outline"  style='width:12px;font-size:12px;padding-right:6px'></i>
            <span v-if="activeName === 'basicConfig'">下拉选项排序说明！：排序一：排序越靠前越方便选择；排序二：可以通过拖动进行调整顺序。</span>
            <span v-if="activeName === 'creditModule'">信用体系用于评估客户与公司贸易往来的风险边界，开启后将在合同制定过程中提供风险节点管理，请慎重修改信用规则代码</span>
            <span v-if="activeName === 'customerSet'">配置说明：提供个人客户库状态转化及公共客户库提取参数设置，请谨慎配置。</span>
            <span v-if="activeName === 'starModule'">星级体系通过客户与公司的历史贸易行为，提供销售人员在销售过程中的报价指导，请谨慎修改规则代码</span>
          </div>
        </div>
        <div class="operation" v-show="activeName === 'basicConfig'" style="padding:20px;margin-top:20px;">
          <el-tabs v-model="activeNameConfig" @tab-click="handleClickBase" type="card">
            <el-tab-pane :label="item.title" :name="item.name" v-for="item in basicConfigList" :key="item.name">
            </el-tab-pane>
          </el-tabs>
        <div style="text-align:right;padding-bottom:20px">
            <el-button type='primary' @click="onSet('add')">添加</el-button>
          </div>
          <el-table
            :data="tableData"
            tooltip-effect="dark"
            :header-cell-style="tableHeader"
            border
            row-key="id">
            <el-table-column v-for="(item, index) in col"
              :key="`col_${index}`"
              :prop="dropCol[index].prop"
              :label="item.label">
              <template slot-scope="scope">
                <div v-if="item.label==='序号'">{{scope.$index+1}}</div>
                <div v-if="item.prop==='flag'">
                  <span v-if="scope.row.flag === true">启用</span>
                  <span v-else>停用</span>
                </div>
                <div v-if="item.prop==='attrName'">
                  <span >{{scope.row.attrName}}</span>
                </div>
                <div v-if="item.prop==='active'">
                  <el-button type="text" v-if="scope.row.flag === true" @click="onDisable(scope.row)">停用</el-button>
                  <el-button type="text" v-else @click="onDisable(scope.row)">启用</el-button>
                  <el-button type="text" @click="onSet(scope.row)">编辑</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>

        </div>
        <!-------------- 客户资料库设置 -------------->
        <div v-show="activeName === 'customerSet'">
          <div class="customer-data">
            <div class="price-add-title">
              <span class="bold add-bold"></span>
              <span class="basic">个人客户库</span>
            </div>
            <el-form :model="queryParams" :inline="true" style="padding:0 30px;">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="休眠转化开关：">
                    <el-switch v-model="queryParams.userIsSleep"></el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="18">
                  <el-form-item label="客户休眠转化期限：" label-width="156px" :rules="filter_rules({required:true})">
                    <el-col :span="20"><el-input  @input.native="onInput" :disabled="queryParams.userIsSleep===false" maxlength="3" v-model.number="queryParams.uisDay" placeholder="请输入整数数字"></el-input></el-col>
                    <el-col :span="4" style='padding-left:10px'>天</el-col>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="客户回收开关：">
                    <el-switch v-model="queryParams.userIsReback"></el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="18">
                  <el-form-item label="休眠客户回收期限：" label-width="156px" :rules="filter_rules({required:true})">
                    <el-col :span="20"><el-input  :disabled="queryParams.userIsReback===false" maxlength="3" v-model.number="queryParams.uirDay" placeholder="请输入整数数字最小为8"></el-input></el-col>
                    <el-col :span="4" style='padding-left:10px'>天</el-col>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="customer-data">
              <div class="price-add-title">
                <span class="bold add-bold"></span>
                <span class="basic">公共客户库</span>
              </div>
              <el-form :model="queryParams" :inline="true" style="padding:0 30px;">
                <el-row>
                  <el-form-item label="允许员工每月提取：">
                    <el-col :span="12">
                      <el-input v-model.number="queryParams.pubCount"></el-input>
                    </el-col>
                    <el-col :span="12" style='padding-left:10px'>份客户资料</el-col>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item label="提取客户成单后，增加：">
                    <el-col :span="12">
                      <el-input v-model.number="queryParams.pubCountAdd"></el-input>
                    </el-col>
                    <el-col :span="12" style='padding-left:10px'>份客户资料提取资格</el-col>
                  </el-form-item>
                </el-row>
              </el-form>
            </div>
            <div style="padding:20px 0;text-align:left;">
              <el-button type="primary" @click="onSetSubmit">提交</el-button>
            </div>
        </div>
        <!-------------- 星级模块设置 -------------->
        <div v-show="activeName === 'starModule'">
          <div class="customer-data">
            <div class="price-add-title">
              <span class="bold add-bold"></span>
              <span class="basic">星级启用开关</span>
              <div class="switch">
                <el-switch v-model="isStar" @change="closeSwitch(isStar,'setStar')"></el-switch>
              </div>
            </div>
            <div style="padding:0 20px 20px 20px;" v-if="isOpenStar">
              <p style="text-align:center;">星级等级及系数设置</p>
              <el-table
                :data="tableDataSettingStar"
                tooltip-effect="dark"
                :header-cell-style="tableHeader"
                border
                >
                <el-table-column prop="starLevel" label="星级等级" ></el-table-column>
                <el-table-column prop="starPoint" label="星级系数" >
                  <template slot-scope="scope">
                    {{scope.row.starPoint *100}}%
                  </template>
                </el-table-column>
                <el-table-column label="操作" >
                  <template slot-scope="scope">
                    <span class="approval" @click="onSetStar('edit',scope.row)">编辑</span>
                  </template>
                </el-table-column>
              </el-table>
              <div style="padding:20px 0;text-align:right;">
                <el-button type="primary" @click="onSetStar('add')" plain>添加</el-button>
                <el-button @click="onDelete">删除</el-button>
              </div>
              <div class="personal-form">
                <el-form ref="formStar"  label-position="left"  :model="formStar">
                  <el-row>
                  <el-form-item label="星级结算期：">
                      <el-col :span="6">
                        <el-radio-group v-model="formStar.settlementType">
                          <el-radio :label="1">自然年</el-radio>
                          <el-radio :label="2">自然季度</el-radio>
                          <el-radio :label="3">自然月</el-radio>
                          <el-radio :label="4">自定义天数</el-radio>
                        </el-radio-group>
                      </el-col>
                      <el-col :span="8" style='text-align:left;padding-left:20px'>
                        <el-col :span="14" style='width:98px'><el-input v-model="formStar.settlementDays" size="mini"></el-input></el-col>
                        <el-col :span="10">（单位：天）</el-col>
                      </el-col>
                  </el-form-item>
                  </el-row>
                  <el-form-item label="客户星级规则代码：" label-width="130px">
                    <el-input type="textarea" v-model="formStar.settlementRules" ></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div style="padding:20px 0;text-align:left;">
                <el-button type="primary" @click="onSubmit">提交</el-button>
              </div>
            </div>
          </div>
        </div>
        <!-------------- 信用模块设置 -------------->
        <div v-show="activeName === 'creditModule'">
          <div>
            <div class="customer-data">
              <div class="price-add-title">
                <span class="bold add-bold"></span>
                <span class="basic">信用启用开关</span>
                <div class="switch">
                  <el-switch @change="closeSwitch(isCredit,'credit')" v-model="isCredit"></el-switch>
                </div>
              </div>
              <div style="padding:0 30px;" v-if="isOpenCredit">
                <el-form :model="creditForm"  label-position="left">
                  <el-row>
                      <el-form-item label="预设固定信用值：">
                        <el-col :span="2">
                          <el-input style='width:150px' v-model="creditForm.creditMoney" placeholder="请填写正整数"></el-input>
                        </el-col>
                        <el-col :span="8" style='padding-left:30px;text-align:left'>添加或导入客户时给予的固定信用值</el-col>
                      </el-form-item>
                  </el-row>
                  <el-row>
                    <el-form-item label="星级结算期：">
                      <el-col :span="6">
                        <el-radio-group v-model="creditForm.settlementType">
                          <el-radio :label="1">自然年</el-radio>
                          <el-radio :label="2">自然季度</el-radio>
                          <el-radio :label="3">自然月</el-radio>
                          <el-radio :label="4">自定义天数</el-radio>
                        </el-radio-group>
                      </el-col>
                        <el-col :span="8" style='text-align:left;padding-left:20px'>
                        <el-col :span="14" style='width:98px'><el-input v-model="formStar.settlementDays" size="mini"></el-input></el-col>
                        <el-col :span="10">（单位：天）</el-col>
                      </el-col>
                    </el-form-item>
                  </el-row>
                  <el-row>
                    <el-form-item label="客户星级规则代码：" label-width="140px">
                      <el-col :span="24">
                        <el-input size="mini" v-model="creditForm.settlementRules" type="textarea"></el-input>
                      </el-col>
                    </el-form-item>
                  </el-row>
                </el-form>
                <div style="padding:20px 0;text-align:left;">
                  <el-button type="primary" @click="onCreditSubmit">提交</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
  <!-------------- 编辑 -------------->
  <edit-set @onRefresh="getQueryByClassCode" ref="editSetRefs"></edit-set>
  <!-------------- 停用或启用品牌 -------------->
    <open-or-close
    ref="OpenOrClose"
    @onUpdataState='onUpdataState'
    :title="title"
    :content='content'></open-or-close>
  <!-------------- 设置系数 -------------->
  <set-coefficient @onRefresh="getSettingStar" ref="setCoefficientRef"></set-coefficient>
  <!-------------- 客户资料库设置,星级模块设置,信用模块设置再次确认 -------------->
  <el-reconfirm @onRefresh="onUpdateData" ref="reconfirmRef"></el-reconfirm>
  <!-------------- 确认星级和信用开关 -------------->
  <open-close @onRefresh="onOpenClose" ref="openCloseRef"></open-close>
</div>
</template>
<script>
import { managementSetList, basicConfigList } from './utils/data'
import {
  querySetting,
  settingStar,
  starDelete,
  settingCreditqueryAll
} from '@/api/customer/customerManage'
import { updateByAttId } from '@/api/system/rightsManagement'
import editSet from './dialog/editSet'
import reconfirm from './dialog/reconfirm'
import setCoefficient from './dialog/setCoefficient'
import openClose from './dialog/openClose'
import Sortable from 'sortablejs'
import OpenOrClose from '@/components/OpenOrClose/index'
export default {
  components: {
    editSet,
    // 'brand-status': brandStatus,
    'set-coefficient': setCoefficient,
    'el-reconfirm': reconfirm,
    'open-close': openClose,
    'open-or-close': OpenOrClose
  },
  data () {
    return {
      col: [
        {
          label: '序号',
          prop: ''
        },
        {
          label: '选项名称',
          prop: 'attrName'
        },
        {
          label: '状态',
          prop: 'flag'
        },
        {
          label: '操作',
          prop: 'active'
        }
      ],
      dropCol: [
        {
          label: '序号',
          prop: 'attrName'
        },
        {
          label: '选项名称',
          prop: 'attrName'
        },
        {
          label: '状态',
          prop: 'flag'
        },
        {
          label: '操作',
          prop: 'address'
        }
      ],
      // tabs名称
      managementSetList: [],
      // 内部tabs名称
      basicConfigList: [],
      activeName: 'basicConfig', // tabs默认选中
      activeNameConfig: 'customer_type', // 内部tabs默认选中
      tableData: [], // 表格数据
      tableDataSettingStar: [], // 星级模块设置
      height: 0,
      title: '', // 停用启用标题
      content: '',
      queryParams: { // 个人客户库
        dormantSwitch: false,
        recycleSwitch: false
      },
      closeCreditDialog: false, // 确认关闭
      formStar: {}, // 星级模块设置
      creditForm: {
        creditMoney: ''
      }, // 信用模块设置
      isStar: false, // 星级模块设置开关
      isOpenStar: false, // 二次确认星级打开
      isOpenCredit: false, // 二次确认信用打开
      isCredit: false// 信用模块设置开关
    }
  },
  mounted () {
    this.rowDrop()
  },
  created () {
    this.height = document.documentElement.clientHeight
    this.managementSetList = managementSetList
    this.basicConfigList = basicConfigList
    this.getQueryByClassCode()
  },
  methods: {
    onInput (e) {
      e.target.value = e.target.value.replace(/\D/g, '')
    },
    // 行拖拽
    rowDrop () {
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      const _this = this
      Sortable.create(tbody, {
        onEnd ({ newIndex, oldIndex }) {
          const currRow = _this.tableData.splice(oldIndex, 1)[0]
          _this.tableData.splice(newIndex, 0, currRow)
          for (let i = 0; i < _this.tableData.length; i++) {
            _this.tableData[i].serial = i
          }
          updateByAttId(_this.tableData).then(res => {
            if (res.data.code === 200) {
            }
          })
        }
      })
    },
    handleClick (tab) {
      this.activeName = tab.name
      if (this.activeName === 'customerSet') { // 客户资料库设置展示
        this.getQuerySetting()
      } else if (this.activeName === 'starModule') { // 星级模块设置展示
        this.getSettingStar()
      } else if (this.activeName === 'creditModule') { // 信用模块设置展示
        this.getSettingCreditqueryAll()
      }
    },
    // 二次确认提交后后刷新列表
    async onUpdateData (val) {
      if (val === 'customerData') {
        this.getQuerySetting()
      } else if (val === 'setStar') {
        this.getSettingStar()
      } else if (val === 'credit') {
        this.getSettingCreditqueryAll()
      }
    },
    // 二次确认星级/信用开关
    onOpenClose (val) {
      if (val === 'setStar') {
        this.getSettingStar()
      } else if (val === 'credit') {
        this.getSettingCreditqueryAll()
      }
    },
    // 基础设置类型
    handleClickBase (tab) {
      this.activeNameConfig = tab.name
      this.getQueryByClassCode()
    },

    async getQueryByClassCode () {
      const params = await this.$queryByClassCodeCRM()
      try {
        if (this.activeNameConfig === 'customer_type') {
          this.tableData = params.customerType
        } else if (this.activeNameConfig === 'industry_type') {
          this.tableData = params.industryTypeList
        } else if (this.activeNameConfig === 'from_type') {
          this.tableData = params.fromTypeList
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 停用启用
    onDisable (row) {
      if (!row.flag) {
        this.title = '启用'
        this.content = '确定启用该选项？'
      } else {
        this.content = '确定停用该选项？'
        this.title = '停用'
      }
      this.$refs.OpenOrClose.onInitial(row)
    },
    // 停用启用品牌
    // onUpdataState() {
    //   this.getQueryByClassCode()
    // },
    async onUpdataState (params) {
      const isUpdate = await this.$onOpenOrClose(params)// 调用公共属性内容启用和停用接口
      if (isUpdate) {
        this.getQueryByClassCode()
      }
    },
    // 添加编辑属性
    onSet (val) {
      this.$refs.editSetRefs.setInit(val, this.activeNameConfig)
    },
    // 客户资料库设置查看
    getQuerySetting () {
      querySetting().then(res => {
        if (res.data.code === 200) {
          res.data.obj.forEach(item => {
            this.queryParams = item
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 客户资料再次确认提交
    onSetSubmit () {
      // if (this.queryParams.userIsSleep || this.queryParams.userIsReback) {
      if (!this.queryParams.uirDay || !this.queryParams.uisDay) {
        this.$message.error('必填项不能为空')
      } else if (this.queryParams.uirDay < 8) {
        this.$message.error('休眠客户回收期限不能低于8天')
      } else {
        this.$refs.reconfirmRef.onInitial('customerData', this.queryParams)
      }
      // }
    },
    // 查看星级模块设置
    getSettingStar () {
      settingStar().then(res => {
        if (res.data.code === 200) {
          this.tableDataSettingStar = res.data.obj.customerSettingStarList
          this.formStar = res.data.obj.cutomerStarSettlement
          this.isStar = res.data.obj.isStar
          this.isOpenStar = res.data.obj.isStar
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 删除星级
    onDelete () {
      starDelete().then(res => {
        if (res.data.code === 200) {
          this.$message.success('删除成功!')
          this.tableDataSettingStar.splice(this.tableDataSettingStar.length - 1, 1)
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 星级再次确认提交
    onSubmit () {
      this.$refs.reconfirmRef.onInitial('setStar', this.formStar)
    },
    // 查看客户信用设置
    getSettingCreditqueryAll () {
      settingCreditqueryAll().then(res => {
        if (res.data.code === 200) {
          this.creditForm = res.data.obj.customerSettingCredit
          this.isCredit = res.data.obj.isCredit
          this.isOpenCredit = res.data.obj.isCredit
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 信用模块提交
    onCreditSubmit () {
      this.$refs.reconfirmRef.onInitial('credit', this.creditForm)
    },
    // 设置系数
    onSetStar (type, row) {
      this.$refs.setCoefficientRef.onInitial(type, row)
    },
    // 星级和信用确认开关
    closeSwitch (val, type) {
      this.$refs.openCloseRef.onInitial(val, type)
    }
  }
}
</script>

<style lang="scss" scoped>

  .customer-data{
    margin-top:20px;
    background: #fff;
  }
</style>
